import useMemoryGameLoop from './useMemoryGameLoop.hook';
import { StyledMemoryGameLoop } from './MemoryGameLoop.styled';
import { GameLoopContext } from '@/shared/GameComponents/GameLoopContext/GameLoopContext';
import { useContext } from 'react';
import FlippableCard from './FlippableCard/FlippableCard';
import { GameStageContext } from '@/shared/GameComponents/GameStageContext/GameStageContext';
import { StyledClassicModalFeedback } from '../../../ClassicGameActivity.styled';
import SoundPlayingIcon from './SoundPlayingIcon/SoundPlayingIcon';

export default function MemoryGameLoop({ onCorrectAnswer, onFinish }) {
  const game = useContext(GameLoopContext);
  const gameStage = useContext(GameStageContext);
  const { actions } = useMemoryGameLoop({
    onCorrectAnswer,
    onFinish,
    game,
  });

  return (
    <StyledMemoryGameLoop>
      <div className="cards">
        {game.state.cards.map((card, index) => (
          <FlippableCard
            key={index}
            concept={card}
            onCardClick={actions.onCardClick}
            disabled={game.state.playingAudio}
            isLastCorrect={game.state.lastCorrectIndex == index}
          />
        ))}
      </div>

      {game.state.playingAudio ? <SoundPlayingIcon /> : null}

      {game.state.finished ? (
        <StyledClassicModalFeedback stage={gameStage.state}>
          <div className="finished-text">
            <p>
              You've sucessfully <br /> matched all the pairs in
            </p>
            <p className="time">
              {game.state.elapsedTime.minutes != '0' && (
                <>{game.state.elapsedTime.minutes} minutes and</>
              )}{' '}
              {game.state.elapsedTime.seconds} seconds.
            </p>

            <p className="title">You're a matching master!</p>
          </div>
        </StyledClassicModalFeedback>
      ) : null}
    </StyledMemoryGameLoop>
  );
}
